import ActivitiesRegistration from './ActivitiesRegistration';

export default ActivitiesRegistration;
